const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. File Upload',
      body: {
        btn: 'Upload',
        hint: 'Select the CSV you want to import',
        downloadExample: 'Download CSV example',
        templateLabel: 'Select Mapping Template (Optional)',
        templateDescription: 'Template loaded. You can view or edit the configuration below if needed.',
        advanced: {
          hint: 'Select the files you want to import',
        },
      },
    },
    mappingFields: {
      title: '2. Mapping Fields',
      subTitle: 'Confirm each attributes is matched the correct column',
      toast: 'Duplicated Value',
      selectInputPlaceHolder: 'Select Field'
    },
    integrityCheck: {
      title: '3. Integrity Check',
      subTitle: 'Cheking the file values',
    },
    import: {
      title: '4. Import',
      subTitle: 'Import the data',
      doneText: 'File Successfully Imported',
      doneBtn: 'Done',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'Fields In DB',
      csvFile: 'CSV File',
      format: 'Format',
      defaultValue: 'Default Value',
    },
    hideTableBtn: 'Hide Table',
    showTableBtn: 'Show Table',
    saveAsTemplateBtn: 'Save as Template',
    templateNameLabel: 'Template Name',
    saveTemplateDescription: 'Save your current field mappings as a template for future use.',
    updateTemplateDescription: 'You can update the existing template {{templateName}} or save as a new template.',
    saveTemplateBtn: 'Save',
    saveAsNewBtn: 'Save as new',
    updateTemplateBtn: 'Update Template',
    nextBtn: 'Next',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'Show only problems',
    disableSubmit: 'Skip Errors',
    totalCount: 'Total: {{count}}',
    exportErrorList: 'Export Error list',
    rowContainErroe: '{{count}} Row contain error.',
    importBtn: 'Import',
    sourceFileColumn: 'Source file',
    sourceRowColumn: 'Source row',
    sourceFileFilterAll: 'All {{count}} source files',
  },

  submit: {
    errors: '{{errors}} rows failed to be pushed',
  }
};

export default dataUpload;
